export default "__VITE_ASSET__Jepy8ZEE__"